import { PhaseForm } from "./_PhaseForm";

export function PhaseEdit() {
  return <PhaseForm action="edit" />;
}

export default PhaseEdit;
